import { z } from 'zod';

export const twoFaSchema = z.object({
    code: z.string().min(1),
});

export type TwoFaValues = z.infer<typeof twoFaSchema>;
